import Req from '../../$axios'

const serviceModule = {
  // 获取oss授权参数
  getPolicy(params) {
    return Req(
      {
        url: 'aliyunOss/getAttachmentUploadPolicy',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // getPolicy(params) {
  //   return Req(
  //     {
  //       url: 'aliyunOss/getOrdinaryAttachmentUploadPolicy',
  //       method: 'get',
  //       isJSON: true,
  //       tip: false,
  //       isAlertErr: true
  //     },
  //     params
  //   )
  // },
  getFileUrl(params) {
    return Req(
      {
        url: 'aliyunOss/getSignUrl',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取oss授权参数
  getOrdinaryAttachmentUploadPolicy(params) {
    return Req(
      {
        url: 'aliyunOss/getDatabaseAttachmentUploadPolicy',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },

  // 获取编辑器附件上传的policy
  getEditPolicy(params) {
    return Req(
      {
        url: 'aliyunOss/getEditorAttachmentUploadPolicy',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 获取跨团队项目附件上传的policy
  getCrossProjectAttachmentUploadPolicy(params) {
    return Req(
      {
        url: 'aliyunOss/getCrossProjectAttachmentUploadPolicy',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  // 编辑器附件上传
  getDocumentEditorAttachmentUploadPolicy(params) {
    return Req(
      {
        url: 'aliyunOss/getDocumentEditorAttachmentUploadPolicy',
        method: 'get',
        isJSON: false,
        tip: false,
        isAlertErr: true
      },
      params
    )
  },
  getProductAttachmentUploadPolicy(params) {
    return Req(
      {
        url: '/aliyunOss/getProductAttachmentUploadPolicy',
        method: 'get',
        isJSON: true,
        tip: false,
        isAlertErr: true
      },
      params
    )
  }
}

export default {
  ...serviceModule
}
